module.exports = __webpack_public_path__ + "static/img/no-diamond-card@3x.bab00059.png";